import { styled } from '@vebox/etui-system';
import { createElement } from 'react';
import { _ as _objectWithoutProperties, a as _objectSpread2 } from '../_rollupPluginBabelHelpers-3b7bd988.js';
import { Div } from '@vebox/etui-system-elements';

const _excluded = ["dividerColor", "theme"];
var DropdownDivider = styled(Div).attrs(_ref => {
  let {
      dividerColor,
      theme
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return _objectSpread2({
    borderTop: `1px solid ${dividerColor || theme.palette.divider}`
  }, props);
})``;

const Divider = ({
  dividerColor
}) => /*#__PURE__*/createElement(DropdownDivider, {
  dividerColor: dividerColor
}, " ");
var Divider$1 = {
  Divider
};

export default Divider$1;
